import { Search, X } from 'lucide-react'
import { useRef } from 'react'

import { Button } from 'src/shared/components/ui/buttons/button'

import useChatStore from '../../store/chat-store'

const ChatSearchBar = () => {
  const query = useChatStore((state) => state.query)
  const setQuery = useChatStore((state) => state.setQuery)
  const inputRef = useRef<HTMLInputElement>(null)

  const handleContainerClick = () => {
    inputRef.current?.focus()
  }

  return (
    <div
      className="relative flex h-[45px] w-full cursor-text items-center rounded-full bg-accent"
      onClick={handleContainerClick}
      role="search"
    >
      <Search className="pointer-events-none absolute left-4 size-4 text-muted" />
      <input
        ref={inputRef}
        type="text"
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        placeholder="Search conversations"
        aria-label="Search conversations"
        className="size-full bg-transparent pl-10 pr-6 text-sm text-primary placeholder:text-muted focus:outline-none"
      />
      {!!query && (
        <Button variant="link" size="sm" onClick={() => setQuery('')}>
          <X className="size-4" />
        </Button>
      )}
    </div>
  )
}

export default ChatSearchBar
